import type SvgProps from '~/components/icons/svg-props'

export default function CheckmarkCircleIcon(props: SvgProps) {
  return (
    <svg
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3327 10.0003C18.3327 14.6027 14.6017 18.3337 9.99935 18.3337C5.39698 18.3337 1.66602 14.6027 1.66602 10.0003C1.66602 5.39795 5.39698 1.66699 9.99935 1.66699C14.6017 1.66699 18.3327 5.39795 18.3327 10.0003ZM13.358 7.47505C13.602 7.71913 13.602 8.11486 13.358 8.35893L9.19129 12.5256C8.94721 12.7697 8.55149 12.7697 8.30741 12.5256L6.64074 10.8589C6.39666 10.6149 6.39666 10.2191 6.64074 9.97505C6.88482 9.73097 7.28055 9.73097 7.52462 9.97505L8.74935 11.1998L10.6117 9.33741L12.4741 7.47505C12.7182 7.23097 13.1139 7.23097 13.358 7.47505Z"
        fill="currentColor"
      />
    </svg>
  )
}
